import PodRoomFetchButton from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomFetchButton.vue'

export default {
  components : {
    PodRoomFetchButton
  },

  data(){
    return {
      isLoadingFetchButton  : false
    };
  },

  methods : {
    async handleLatestFetchButtonClick(room){
      if(this.isPullToRunning === true) return;
      
      this.isLoadingFetchButton = true;

      this.$store.dispatch({
        type      : 'connection/updatePodRoomData',
        podRoomId : room.id,
        page      : null
      });

      await this.UXWaiting(500);

      this.$store.dispatch({
        type      : 'connection/updatePodRoomData',
        podRoomId : room.id,
        page      : 1
      });

      await this.waitLoading(
        this.$apollo.queries.podMessages.loading, 1000, 5
      );

      this.isLoadingFetchButton = false;
    }
  }
}